<div style="padding: 1cm;">

  <!-- TOP BAR -->
  <div style="display:flex; justify-content:flex-end; gap:12px; margin-bottom:20px;" class="noPrint">
    <span style="font-size:12px; color:gray;">
      Total Groups: {{ groups?.length || 0 }}
    </span>
    <button mat-raised-button color="primary"
        (click)="print()">
  Print
</button>
    <button mat-raised-button (click)="close()">
      Close
    </button>
  </div>

  <!-- PRINT AREA -->
  <div id="print-section" style="background:#fff;">

    <!-- EMPTY STATE -->
    <div *ngIf="!groups || groups.length === 0"
         style="text-align:center; color:red; padding:30px;">
      No Data Found
    </div>

    <!-- ONE PAGE PER DISTRIBUTIVE REP -->
    <div *ngFor="let grp of groups; let last = last"
         [style.page-break-after]="last ? 'auto' : 'always'"
         style="padding:1cm;">

      <!-- HEADER -->
      <div style="font-weight:bold; margin-bottom:10px;">
        <div>वितरण प्रतिनिधी: {{ grp.DistributiveRep }}</div>
      </div>

      <!-- LABEL GRID -->
      <div style="display:flex; flex-wrap:wrap; gap:12px;">

        <div *ngFor="let item of grp.records"
             style="width:23%; border:1px solid #000; padding:10px; font-size:13px; box-sizing:border-box;">

          <!-- NAME + QTY -->
          <div style="display:flex; justify-content:space-between; font-weight:bold;">
            <span>{{ item.name }}</span>
            <span> {{ item.book_copies }}</span>
          </div>

          <!-- ADDRESS -->
          <div>{{ item.address }}</div>

          <!-- TALUKA -->
          <div *ngIf="item.taluka">{{ item.taluka }}</div>

          <!-- DISTRICT / PINCODE / STATE -->
          <div>
            <span *ngIf="item.district">{{ item.district }}</span>
            <span *ngIf="item.pincode"> - {{ item.pincode }}</span>
            <span *ngIf="item.state"> {{ item.state }}</span>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
